export const USER_FLAG_PROVIDER_DATA = {
  showWalletGiftCodeLandingModal: true,
  showMobilePageFAQHighlight: true,
  showWalletGiftCodeFAQHighlight: true,
  raffleLandingModalNumberOfViews: 0,
  abTestingValues: '',
};
